import * as React from "react"
import * as Money from "../../util/money"

interface Props {
  checked: boolean
  onChange: (values: object) => void
  amountCents: number
}

export function RecipientAmountCheckbox(props: Props) {
  return (
    <>
      <input
        type="checkbox"
        className="-mb-2"
        onChange={props.onChange}
        checked={props.checked}
        data-role={"amount-checkbox"}
      />
      <span> Apply {Money.formatCentsAsUsd(props.amountCents)}</span>
    </>
  )
}
